import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { api } from "../api";
import FixedCard from "../components/FixedCard";
import SEO from "../components/SEO";

const ACCENT = ["#8A1613","#007965","#8A1613","#007965","#8A1613","#007965"];

const DEFAULT_SERVICES = [
  { icon: "🎯", title: "Health Campaign Strategy",      description: "Brainstorming, planning messaging, campaign concepts, audience mapping and creative direction." },
  { icon: "🎬", title: "Multimedia Content Creation",   description: "Videos, photos, infographics, reels, scripts, social media and digital storytelling." },
  { icon: "📰", title: "PR & Media Relations",          description: "Press releases, media pitching, interview coordination and campaign visibility." },
  { icon: "🎙", title: "Podcast & Youth Health Content", description: "Sponsored series, youth conversations, expert interviews and myth-busting." },
  { icon: "🌍", title: "Community Health Activations",  description: "Live events, school-based content, youth engagement and campaign documentation." },
  { icon: "🗣", title: "Multilingual Health Comms",     description: "Translation, culturally relevant messaging for all South African communities." },
];

export default function Services() {
  const [services, setServices] = useState([]);
  const [loading, setLoading]   = useState(true);

  useEffect(() => {
    api.getServices().then(setServices).catch(() => {}).finally(() => setLoading(false));

  }, []);

  const displayServices = services.length > 0 ? services : DEFAULT_SERVICES;

  return (
    <>
    <SEO
      title="Services"
      path="/services"
      description="Health campaign strategy, multimedia content creation, PR and media relations, podcast production, community health activations and multilingual communications. We help organisations reach young South Africans."
    />
    <div style={{ paddingTop: "5rem" }}>

      <section style={{ background: "#0B0B0B", padding: "6rem 2rem 5rem" }}>
        <div className="container">
          <p className="section-label" style={{ color: "#95BB83" }}>What We Do</p>
          <h1 style={{ fontFamily:"var(--font)", fontWeight:900, fontSize:"clamp(2.8rem,7vw,6rem)", color:"#fff", lineHeight:0.95, letterSpacing:"-0.03em", marginBottom:"1.5rem" }}>
            What<br /><span style={{ color:"#8A1613" }}>We Do.</span>
          </h1>
          <p style={{ color:"rgba(255,255,255,0.55)", maxWidth:560, fontSize:"1.05rem", lineHeight:1.75, fontFamily:"var(--font-body)" }}>
            We help companies and organisations create health communications that speak to communities all over the country. Through mixed media tools we package health information in the language that people can understand, share and act on.
          </p>
        </div>
      </section>

      <section style={{ background:"#F7F1DF", padding:"6rem 2rem" }}>
        <div className="container">
          {loading && <p style={{ color:"rgba(11,11,11,0.4)", fontFamily:"var(--font-body)" }}>Loading…</p>}
          {!loading && (
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill, minmax(280px, 1fr))", gap:"1.25rem" }}>
              {displayServices.map((s, i) => {
                const color = ACCENT[i % ACCENT.length];
                return (
                  <FixedCard
                    key={s.id || i}
                    height={300}
                    headerHeight={90}
                    accentColor={color}
                    headerContent={
                      <div style={{ zIndex:1, position:"relative", display:"flex", alignItems:"center", justifyContent:"center", width:"100%", height:"100%" }}>
                        <div style={{ width:56, height:56, borderRadius:14, background:"rgba(255,255,255,0.18)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:"1.6rem" }}>
                          {s.icon}
                        </div>
                      </div>
                    }
                    title={s.title}
                    body={s.detail ? `${s.description}\n\n${s.detail}` : s.description}
                    previewLines={3}
                    modalTitle={s.title}
                    modalIcon={s.icon}
                  />
                );
              })}
            </div>
          )}
        </div>
      </section>

      <section style={{ background:"#8A1613", padding:"5rem 2rem", textAlign:"center" }}>
        <div className="container-sm">
          <h2 style={{ fontFamily:"var(--font)", fontWeight:900, fontSize:"clamp(2rem,4vw,3rem)", color:"#fff", marginBottom:"1rem", letterSpacing:"-0.02em" }}>Let's Operate.</h2>
          <p style={{ color:"rgba(255,255,255,0.65)", marginBottom:"2rem", fontFamily:"var(--font-body)", fontSize:"1.05rem" }}>Tell us what you need. And we will take it from there.</p>
          <Link to="/contact" className="btn-outline-white">Plan a Health Campaign</Link>
        </div>
      </section>

    </div>
    </>
  );
}
